// const mxModule = require("mxgraph")();
// const {
//     mxCylinder, mxPoint, mxConnectionConstraint, mxConstants
//   } = mxModule;
import { mxCylinder, mxPoint, mxConnectionConstraint, mxConstants } from "../utils/graph/mxModule";

function vssShape() { }
    vssShape.prototype = new mxCylinder();
    vssShape.prototype.constructor = vssShape;

    vssShape.prototype.constraints = [
        new mxConnectionConstraint(new mxPoint(0.5, 0), true),  // Vss
      ];

    vssShape.prototype.paintVertexShape = function (c, x, y, w, h) {
        const scaleX = w / 48;
        const scaleY = h / 42;
      
        // === Vertical center green line ===
        c.setStrokeColor('#00cc66');
        c.setStrokeWidth(2);
        c.begin();
        c.moveTo(x + 24 * scaleX, y + 0);
        c.lineTo(x + 24 * scaleX, y + 42 * scaleY);
        c.stroke();
      
        // === Bottom horizontal green line ===
        c.begin();
        c.moveTo(x + 0, y + 42 * scaleY);
        c.lineTo(x + 48 * scaleX, y + 42 * scaleY);
        c.stroke();
      
        // === "VSS" text in red near bottom-right ===
        c.setFontColor('#fd0000');
        c.setFontSize(9 * scaleX);
        c.setFontFamily('Arial');
        c.text(
          x + 36 * scaleX,         // 75% of 48
          y + 31.5 * scaleY,       // 75% of 42
          0, 0,
          'VSS',
          mxConstants.ALIGN_CENTER,
          mxConstants.ALIGN_MIDDLE,
          false,
          null,
          0, 0, 0
        );
      };
      

    export default vssShape